export const getDestinos = 'destinos'
